/**
 * Rest-P2P icin sadece bir cache. QuickSaleScreen (veya hook) aktif olan
 * config'i buraya yazar; pavopay.ts gibi hook-disi helper'lar da buradan okur.
 *
 * Boylece helper'lar (cancelPavoPaySale, getReturnableSale, processPartialReturn, ...)
 * kendi ici mantiklarinda React context'ine ihtiyac duymadan Rest-P2P dalina
 * delegasyon yapabilir.
 */

export interface RestP2PConfigSnapshot {
  enabled: boolean;
  deviceCode: string | null;
  companyId: string | null;
  branchId: string | null;
}

let current: RestP2PConfigSnapshot = {
  enabled: false,
  deviceCode: null,
  companyId: null,
  branchId: null,
};

export function setRestP2PConfig(config: Partial<RestP2PConfigSnapshot>): void {
  current = {
    ...current,
    ...config,
  };
  try {
    // Refresh/HMR sonrasi kurtarma icin
    localStorage.setItem('gts_restp2p_config', JSON.stringify(current));
  } catch (_) {}
}

export function clearRestP2PConfig(): void {
  current = { enabled: false, deviceCode: null, companyId: null, branchId: null };
  try { localStorage.removeItem('gts_restp2p_config'); } catch (_) {}
}

export function getRestP2PConfig(): RestP2PConfigSnapshot {
  if (!current.enabled) {
    try {
      const raw = localStorage.getItem('gts_restp2p_config');
      if (raw) {
        const parsed = JSON.parse(raw) as RestP2PConfigSnapshot;
        if (parsed && typeof parsed.enabled === 'boolean') {
          current = parsed;
        }
      }
    } catch (_) {}
  }
  return current;
}

export function isRestP2PActive(): boolean {
  const c = getRestP2PConfig();
  return Boolean(c.enabled && c.deviceCode);
}
